import {
  CloseOutlined,
  DownloadOutlined,
  EditOutlined,
  EyeOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { AllCommunityModule, ColDef, ModuleRegistry } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { Badge, Breadcrumb, ConfigProvider, Input, Pagination, Select, Switch, Tag, Tooltip, TreeSelect } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import Layout from '../../../Layout';
import { getListGroup } from '../../../api/groupCustomerV2/groupCustomerV2Api';
import * as IssuedCardsApi from '../../../api/rank/issuedCardApi';
import * as RankApi from '../../../api/rank/rankApi';
import { convertGroupValueToTree } from '../../../api/unit/unitApi';
import { none_rank } from '../../../components/ExportImgFigma';
import ModalCardIssuance from '../../../components/Modal/ModalCardIssuance';
import ModalUpload from '../../../components/Modal/ModalUpload';
import { API_URL, LIMIT_EXPORT_EXCEL, NO_DATA, URL_RANK } from '../../../env';
import useDebounce from '../../../hook/useDebounce';
import useLoading from '../../../hook/useLoading';
import useThrottle from '../../../hook/useThrottle';
import useToast from '../../../hook/useToast';
import { formatNumber } from '../../../services/mixin';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { CustomLoadingOverlayTable, dataPagination, fommatSelectOptionV2, getPermissionClass, getUserPermissions } from '../../../until';
import { NodataTable } from '../../../components/NoDataTable';
import './CardIssuance.scss';
import { FIELDTYPE, NO_VIEW } from '../../../services/data';
import { getListFieldsByCustomer, ListField } from '../../../api/Customer_V2/customerApi_V2';
import CustomerFeilds from '../../CustomersV2/Drawer/CustomerFeilds';
import { FlattenedField } from '../../CustomersV2/indexV2';
import DrawerAddCard from './Drawer/DrawerAddCard';
import DrawerEditCard from './Drawer/DrawerEditCard';
import ShowDetailUserCard from './ShowDetailUserCard';
import CustomerVoucherFeilds from '../../Marketing/VoucherComponents/CustomerVoucherFeilds';

ModuleRegistry.registerModules([AllCommunityModule]);

const { Search } = Input;

export const STATUS_OPTIONS = [
  {
    value: 1,
    label: "Hoạt động",
  },
  {
    value: 0,
    label: "Tạm khoá",
  },
  {
    value: 2,
    label: "Hết hạn",
  },
  {
    value: 3,
    label: "Chưa phát hành",
  },
];

const CardIssuance: React.FC = () => {
  const [paginationTmp, setPaginationTmp] = useState<number>(1)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [dataIssuedCards, setDataIssuedCards] = useState<IssuedCardsApi.DataTypeIssuedCards[]>([])
  const pushToast = useToast();
  const pushLoading = useLoading()
  const navigate = useNavigate()

  const location = useLocation();
  const { unitTemp } = useSelector(selectorInfoUser)

  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, upload, download, access } = getUserPermissions(permissionSlice, location.pathname)

  const [isAddCardUser, setAddCardUser] = useState(false)
  const [accessSelectFilter, setAccessActive] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isUserCard, setUserCard] = useState(false)
  const [isAddCard, setAddCard] = useState(false)
  const [isEditCard, setEditCard] = useState(false)
  const [openUploadDSCard, setOpenUploadDSCard] = useState(false)
  const [typeCard, settypeCard] = useState<number | undefined>(undefined)
  const [rankId, setRankId] = useState<number | undefined>(undefined)
  const [search, setSearch] = useState<string>('')
  const [dataInfoCardCustomer, setDataInfoCardCustomer] = useState<IssuedCardsApi.IInfoCardCustomer>()
  const [idEdit, setIdEdit] = useState<number>(0)
  const [listGroup, setListGroup] = useState<any[]>([])
  const [groupSelect, setGroupSelect] = useState<number[] | undefined>(undefined)
  const [searchGroup, setSearchGroup] = useState<string>('')

  const [lastId, setLastId] = useState<number | undefined>(undefined)
  const [total, setTotal] = useState<number | undefined>(undefined)
  const [lastCardId, setLastCardId] = useState<number | undefined>(undefined)

  const gridRef = useRef<AgGridReact>(null);
  const hasSelected = selectedRowKeys.length > 0;

  const [dataRank, setDataRank] = useState<RankApi.IRank[]>([])
  const [isSettingShow, setSettingShow] = useState(false)
  const [activeFields, setActiveFields] = useState<FlattenedField[]>([])
  const [inactiveFields, setInactiveFields] = useState<ListField[]>([])

  const gListFieldsActive = async () => {
    const result = await getListFieldsByCustomer(FIELDTYPE.CardIssuanceDetail, 1)
    if (result?.status) {
      const flattenedFields: FlattenedField[] = result.data.flatMap(choice =>
        choice.fields.map(field => ({
          ...field,
          parentId: choice.id,
        }))
      );
      setActiveFields(flattenedFields)
      gListFieldsNotActive()
    }
  }

  const gListFieldsNotActive = async () => {
    const result = await getListFieldsByCustomer(FIELDTYPE.CardIssuanceDetail, 0)
    if (result?.status) {
      setInactiveFields(result.data)
    }
  }

  const onSaveDataFields = (iSsuccess?: boolean, message?: string, updatedActive?: FlattenedField[], updatedInactive?: ListField[]) => {
    if (iSsuccess) {
      setSettingShow(false)
      pushToast(message, "success")
      setActiveFields(updatedActive ?? [])
      setInactiveFields(updatedInactive ?? [])
    } else {
      pushToast(message, "warning")
    }
  }

  const setActiveHiddenFilter = () => {
    setAccessActive(false)
  };

  const gSLGroup = useDebounce(async () => {
    const result = await getListGroup([],
      undefined, undefined, undefined, undefined,
      searchGroup, undefined, undefined, undefined,
      unitTemp);
    if (result?.status) {

      setListGroup(convertGroupValueToTree(result.data))
    }
  }, 500)

  const getListIssuedCards = useDebounce(async (limit: number = 10, pageNumber: number = 1, lastId?: number, lastCardId?: number) => {
    pushLoading(true)
    //  limit, pageNumber, lastId, lastCardId,type,rankId, search,  unitScopeId, listGroupCustomer
    const result = await IssuedCardsApi.getListIssuedCards(limit, pageNumber, lastId, lastCardId, typeCard, rankId, search, unitTemp, groupSelect);
    if (result?.status) {
      setLastCardId(result.nextLastCardId)
      setLastId(result.nextLastId)
      setDataIssuedCards(convertData(result.data, pageNumber, limit))
      setPagination({ current: pageNumber, total: result.total, pageSize: limit })
      setPaginationTmp(pageNumber)
      setTotal(result.total)
    } else {
      pushToast(result?.message, "error", 2000)
    }
    pushLoading(false)
  }, 1000)
  const convertData = (data: IssuedCardsApi.IIssuedCards[], pageNumber: number, limit: number) => {
    var stt = (pageNumber - 1) * limit + 1;

    const convertData = data?.map((item: any) => {
      // Map fields[] array by fieldCode (like CustomerList_V2)
      const fieldValues: Record<string, any> = {};
      if (item.fields?.length) {
        item.fields.forEach((f: any) => {
          fieldValues[f.fieldCode] = f.view === false ? NO_VIEW : f.value;
        });
      }

      return {
        key: item.id,
        stt: stt++,
        // keep legacy mapped fields for action column / export
        mt: item.codeCard,
        name: item.name,
        ht: item.rank?.title,
        nph: item.releaseDate,
        nhh: item.expirationDate,
        status: item.status,
        icon: item.rank?.icon,
        listCarePolicies: item.listCarePolicies,
        addType: item.addType,
        point: item.point,
        permissionMenu: item.permissionMenu,
        // spread dynamic field values (cus_name, rank, release_date, etc.)
        ...fieldValues,
      };
    })
    return convertData
  }
  const getListRank = async () => {
    const result = await RankApi.getListRank();
    if (result?.status) {
      setDataRank(result.data)
    } else {
      pushToast(result?.message, "error", 2000)

    }
  }
  // lấy thông tin khahcs hàng để cho vào chỉnh sửa
  const getInfoCardCustomer = async (id: number) => {
    const result = await IssuedCardsApi.getInfoCardCustomer(id);
    if (result.status) {
      setDataInfoCardCustomer(result.data);
    } else {
      pushToast(result.message, "error", 2000)

    }
  }
  const confirmDrawerEdit = (isSucces: boolean, errorMesses?: string) => {
    if (isSucces) {
      setEditCard(false)
      pushToast("Chỉnh sửa phát hành thẻ thành công", "success")
      getListIssuedCards()
    } else {
      pushToast(errorMesses, "success")
    }
  }
  const confirmModalAdd = (isSucces: boolean, errorMesses?: string) => {
    if (isSucces) {
      setAddCardUser(false)
      setAddCard(false)
      pushToast("Phát hành thẻ thành công", "success")
      getListIssuedCards()
    } else {
      pushToast(errorMesses, "warning")
    }
  }

  const updateActiveIssuedCards = async (id: number) => {
    const result = await IssuedCardsApi.updateActiveIssuedCards(id);
    if (result?.status) {
      getListIssuedCards(pagination.pageSize, pagination.current)
      pushToast(result.message, "success", 2000)
    } else {
      pushToast(result.message, "error", 2000)

    }
  }
  // ── Special cell renderers for known field codes ──
  const cardCodeRenderer = (p: any) => {
    const record = p.data;
    return record.status === 2 || record.status === 3
      ? <span className="t-op-40">Chưa phát hành</span>
      : <span>{p.value}</span>;
  };
  const rankRenderer = (p: any) => {
    const record = p.data;
    if (record.status === 2 || record.status === 3) {
      return (
        <div className="ctrl-title-ht">
          <div className="img-box"><img src={none_rank} style={{ width: 20, height: 20, objectFit: 'cover' }} alt="" /></div>
          <span className="t-op-40">Chưa phát hành</span>
        </div>
      );
    }
    return (
      <div className="ctrl-title-ht">
        <div className="img-box">
          <img src={URL_RANK + record.icon} style={{ width: 20, height: 20, objectFit: 'cover' }} onError={(e: any) => { e.currentTarget.src = none_rank; }} alt="" />
        </div>
        <span className="text">{p.value}</span>
      </div>
    );
  };
  const dateRenderer = (p: any) => {
    const record = p.data;
    return record.status === 2 || record.status === 3
      ? <span className="t-op-40">Chưa phát hành</span>
      : <span>{p.value}</span>;
  };
  const statusRenderer = (p: any) => {
    const record = p.data;
    if (record.status === 3) return <span className="t-op-40">Chưa phát hành</span>;
    if (record.status === 1) return <Badge status="success" text="Hoạt động" />;
    if (record.status === 0) return <Badge status="warning" text="Tạm khóa" />;
    if (record.status === 2) return <Badge status="error" className="t-op-40" text="Hết hạn" />;
    return null;
  };
  const carePoliciesRenderer = (p: any) => {
    const record = p.data;
    if (record.status === 2 || record.status === 3) return <span className="t-op-40">Chưa phát hành</span>;
    return (
      <Tooltip title={p.value}>
        <div style={{ display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2, overflow: 'hidden', textOverflow: 'ellipsis', wordBreak: 'break-word' }}>
          {p.value || NO_DATA}
        </div>
      </Tooltip>
    );
  };
  const addTypeRenderer = (p: any) => {
    const record = p.data;
    if (record.status === 2 || record.status === 3) return <span className="t-op-40">Chưa phát hành</span>;
    if (p.value === 0) return <Tag color="green">Thủ công</Tag>;
    if (p.value === 1) return <Tag color="blue">Tự động</Tag>;
    return <span>{NO_DATA}</span>;
  };
  const pointRenderer = (p: any) => {
    const record = p.data;
    if (record.status === 2 || record.status === 3) return <span className="t-op-40">Chưa phát hành</span>;
    return <span>{p.value !== undefined ? formatNumber(p.value) : NO_DATA}</span>;
  };

  const specialRenderers: Record<string, (p: any) => React.ReactNode> = useMemo(() => ({
    // short names
    mt: cardCodeRenderer, codeCard: cardCodeRenderer,
    ht: rankRenderer, rankTitle: rankRenderer,
    nph: dateRenderer, releaseDate: dateRenderer,
    nhh: dateRenderer, expirationDate: dateRenderer,
    status: statusRenderer,
    listCarePolicies: carePoliciesRenderer, carePolicy: carePoliciesRenderer,
    addType: addTypeRenderer,
    point: pointRenderer,
  }), []);

  const columnDefs = useMemo<ColDef[]>(() => {
    const actionColumn: ColDef = {
      headerName: 'Hành động',
      field: 'key',
      width: 200,
      sortable: false,
      resizable: false,
      lockPinned: true,
      lockPosition: 'left',
      suppressMovable: true,
      suppressSizeToFit: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      editable: false,
      cellRenderer: (p: any) => {
        const record: IssuedCardsApi.DataTypeIssuedCards = p.data;
        if (record.status === 2 || record.status === 3) {
          return (
            <div className="d-flex gap-2 justify-center align-center h-full px-1 t-op-40">
              <EyeOutlined className={`${getPermissionClass(access)} 'text-sm border-D9D9D9 p-5-px bg-white rounded-2'`} />
              <EditOutlined className={`${getPermissionClass(edit)} 'text-sm border-D9D9D9 p-5-px bg-white rounded-2'`} />
              <Switch defaultChecked={false} onChange={() => updateActiveIssuedCards(Number(record.key))} />
            </div>
          );
        }
        return (
          <div className="d-flex gap-2 justify-center align-center h-full px-1">
            <EyeOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer  ${getPermissionClass(access)}`}
              onClick={() => { setUserCard(true); getInfoCardCustomer(record.key); }}
            />
            <EditOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer  ${getPermissionClass(edit)}`}
              onClick={() => { setIdEdit(record.key); setEditCard(true); getInfoCardCustomer(record.key); }}
            />
            <Switch defaultChecked={!!record.status} onChange={() => updateActiveIssuedCards(Number(record.key))} />
          </div>
        );
      },
    };

    const dynamicColumns: ColDef[] = activeFields.map(field => {
      const col: ColDef = {
        headerName: field.fieldLabel,
        field: field.fieldCode,
        minWidth: 130,
        flex: 1,
        resizable: true,
      };

      if (specialRenderers[field.fieldCode]) {
        col.cellRenderer = specialRenderers[field.fieldCode];
      }

      return col;
    });

    return [actionColumn, ...dynamicColumns];
  }, [activeFields, specialRenderers]);

  const handleChangePagination = (current: number, pageSize: number, typeCard?: number, rankId?: number, search?: string) => {
    setPaginationTmp(current);
    setPagination((prev) => ({ ...prev, current: current, pageSize }))
    getListIssuedCards(pageSize, current, lastId, lastCardId)
  }
  useEffect(() => {
    getListRank()
    gListFieldsActive()
  }, [])


  const glistByExcel = useThrottle(async () => {
    const result = await IssuedCardsApi.getListIssuedCards(
      LIMIT_EXPORT_EXCEL, 1, lastId, lastCardId, typeCard, rankId, search, unitTemp, groupSelect
    )
    if (result?.status) {
      formattedDataExcel(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }, 1000)

  const formattedDataExcel = (data: IssuedCardsApi.IIssuedCards[]) => {
    const formattedData = data.map((item) => {
      return {
        "Họ và tên": item.name,
        "Hạng thẻ": item.rank,
        "Ngày phát hành": item.releaseDate,
        "Ngày hết hạn": item.expirationDate,
        "Trạng thái thẻ": item.status === 0 ? "Tạm khóa" : item.status === 1 ? "Hoạt Động" : item.status === 2 ? "Hết hạn" : 'Chưa phát hành',
      }
    }
    );
    exportExcel(formattedData)
  }
  const glistByExcelChoose = useThrottle(async () => {
    const result = await IssuedCardsApi.getListIssuedCards(
      LIMIT_EXPORT_EXCEL, 1, lastId, lastCardId, typeCard, rankId, search, unitTemp, groupSelect
    )
    if (result?.status) {
      formattedDataExcelChoose(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }, 1000)

  const formattedDataExcelChoose = (data: IssuedCardsApi.IIssuedCards[]) => {
    const filteredData = data.filter(item => selectedRowKeys.includes(item.id));
    const formattedData = filteredData.map((item) => {
      return {
        "Họ và tên": item.name,
        "Hạng thẻ": item.rank,
        "Ngày phát hành": item.releaseDate,
        "Ngày hết hạn": item.expirationDate,
        "Trạng thái thẻ": item.status === 0 ? "Tạm khóa" : item.status === 1 ? "Hoạt Động" : item.status === 2 ? "Hết hạn" : 'Chưa phát hành',
      }
    }
    );
    exportExcel(formattedData)
  }

  function exportExcel(convertData: any): boolean {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Danh sách');

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
        const link: HTMLAnchorElement = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${"Danh sách Phát hành thẻ"}.xlsx`);
      return true; // Export successful
    } catch (error) {
      console.error('Error exporting Excel:', error);
      return false; // Export failed
    }
  }


  const onSelectionChanged = () => {
    const rows =
      gridRef.current?.api.getSelectedRows() ?? [];

    setSelectedRowKeys(
      rows.map((x) => x.key)
    );
  };

  const isRowSelectable = (params: any) => {
    return params.data?.status !== 1 && params.data?.status !== 0;
  };



  useEffect(() => {

    if (!gridRef.current) return;

    if (!gridRef.current.api) return;

    gridRef.current.api.forEachNode(node => {

      node.setSelected(
        selectedRowKeys.includes(node.data.key)
      );

    });

  }, [dataIssuedCards]);

  useEffect(() => {
    getListIssuedCards()

  }, [typeCard, search, rankId, groupSelect]);


  useEffect(() => {
    gSLGroup()
  }, [searchGroup])
  return (
    <div className='card-issuance-list'>
      <Layout>

        <CustomerVoucherFeilds
          isSettingShow={isSettingShow}
          recordId={FIELDTYPE.CardIssuanceDetail}
          dataFilterActive={activeFields}
          dataFilterNoActive={inactiveFields}
          onSaveDataFields={onSaveDataFields}
          onClose={() => setSettingShow(false)}
        />

        <DrawerEditCard
          id={idEdit}
          isOpen={isEditCard}
          dataInfoCardCustomer={dataInfoCardCustomer}
          dataRank={dataRank}

          closeDrawer={() => setEditCard(!isEditCard)}
          confirmDrawerEdit={confirmDrawerEdit}
        />

        <DrawerAddCard
          isOpen={isAddCardUser}
          dataRank={dataRank}

          closeDrawer={() => setAddCardUser(false)}
          confirmModalAdd={confirmModalAdd}
        />

        {/* {
          isAddCardUser && <ShowAddCard
            dataRank={dataRank}

            onClose={() => { setAddCardUser(false) }}
            confirmModalAdd={confirmModalAdd}
          />
        } */}

        <ModalUpload
          isOpen={openUploadDSCard}
          closeModal={() => setOpenUploadDSCard(!openUploadDSCard)}

          linkSampleFile={"https://api.thacocrm.bdata.link/uploads/fileExcel/cardIssuance/Danhsachphathanhthe.xlsx"}
          linkUploandFile={`${API_URL}rank/importExcel`}
        />

        <ModalCardIssuance
          isOpen={isAddCard}
          dataRank={dataRank}
          selectedRowKeys={selectedRowKeys}
          closeModal={() => setAddCard(false)}
          setSelectedRowKeys={setSelectedRowKeys}
          confirmModalAdd={confirmModalAdd}

        />

        <Breadcrumb
          items={[
            {
              title: 'THACO AUTO CRM',
            },
            {
              title: <a href="/">Chương trình KH thành viên</a>,
            },
            {
              title: 'Phát hành thẻ',
            },
          ]}
        />

        <div className='title-page'>
          Phát hành thẻ ({formatNumber(total ?? 0)})
        </div>

        {/* Fillter block */}
        <div className={`filter-block ${hasSelected ? "active" : ""}`}>
          <div className='custom-page-css  border rounded overflow-hidden'
            style={{
              width: 400
            }}
          >
            <Search placeholder="Tìm kiếm Họ và tên" value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className="custom-page-css flex flex-2 overflow-hidden">
            <TreeSelect
              className='custom-page-css  border rounded overflow-hidden w-full custom-scroll-multi-select'
              multiple
              // className='t-search-block'
              showSearch
              placeholder="Nhóm khách hàng"
              allowClear
              // value={dataFilterTmp.group}
              treeDefaultExpandAll={false}
              treeData={listGroup}
              filterTreeNode={false}
              onSearch={(value) => setSearchGroup(value)}
              onBlur={() => setSearchGroup('')}
              onChange={(e) => setGroupSelect(e !== undefined ? e : undefined)}
              onClear={() => setSearchGroup('')}
            />
          </div>

          <div className="custom-page-css flex flex-1 overflow-hidden">
            <Select
              className='custom-page-css border rounded overflow-hidden  w-full'
              placeholder="Trạng thái thẻ"
              allowClear
              onClear={() => settypeCard(undefined)}
              onChange={(e) => settypeCard(e)}
              value={typeCard}
              options={STATUS_OPTIONS}
            />
          </div>

          <div className="custom-page-css flex flex-1 overflow-hidden">
            <Select
              className='custom-page-css border rounded overflow-hidden  w-full'
              placeholder="Hạng thẻ"
              allowClear
              onClear={() => setRankId(undefined)}
              onChange={(e) => setRankId(e)}
              value={rankId}
              options={fommatSelectOptionV2(dataRank)}
            />
          </div>


          {/* <div className='filter-select filter-select2'>
            <div
              className='btn-select-show'
            >
              <span className="content-select" onClick={() => setFilterTypeRank(true)} >Loại thẻ</span>
              <div
                className={`icon-down ${isFilterTypeRank ? "active" : ""}`}
                onClick={() => setFilterTypeRank(true)}
              >
                <DownOutlined />
              </div>
              <div
                className={`icon-close ${isFilterTypeRank ? "active" : ""}`}
                // Nhờ anh check lại chỗ này, vì khi mình mở modal thì chỗ này nó bị backup modal che rồi nên k thể click dc
                onClick={() => console.log('object')}
              >
                <CloseCircleOutlined />
              </div>
            </div>
            {
              isFilterTypeRank
                ? <SelectFilterTypeRank
                  className="show"
                  onClose={() => { setFilterTypeRank(false) }}
                  setRankId={setRankId}
                  rankId={rankId}
                  dataRank={dataRank}
                />
                : null
            }
          </div> */}

          <div className={`${getPermissionClass(download)} btn-input`}
            onClick={glistByExcel}
          >
            <div className="icon-svg">
              <DownloadOutlined />
            </div>
            <div className="text">Xuất DS</div>
          </div>

          {/* <div className="btn-input btn-input2"
            onClick={() => setOpenUploadDSCard(true)}
          >
            <div className="icon-svg">
              <UploadOutlined />
            </div>
            <div className="text">Nhập DS</div>
          </div> */}

          <div className="btn-input custom-page-css flex justify-center"
            onClick={() => navigate('/member-card/card-issuance-history')}
          >
            {/* <div className="icon-svg">
              <UploadOutlined />
            </div> */}
            <div className=" text text-center">Lịch sử</div>
          </div>

          <div className={`${getPermissionClass(add)} btn-input btn-primary`}

          >
            <div
              className="text"
              onClick={() => setAddCardUser(true)}
            >
              Phát hành thẻ
            </div>
          </div>

          <div className=" btn-input custom-page-css flex justify-center items-center p-1 border rounded cursor-pointer" style={{ width: 40, }} onClick={() => setSettingShow(true)}>
            <div className="icon-svg" onClick={() => setSettingShow(true)}>
              <SettingOutlined />
            </div>
          </div>
        </div>

        {/* Fillter block */}
        <div className={`filter-block filter-active-show ${hasSelected ? "active" : ""}`}>
          <div className='total-chosse'>
            {hasSelected ? `Đã chọn ${selectedRowKeys.length} khách hàng` : ''}
          </div>

          <div className="btn-primary-auto" onClick={() => setAddCard(true)}>
            <div className="text">{`Phát hành ${selectedRowKeys.length} thẻ`}</div>
          </div>

          <div className="btn-input" onClick={glistByExcelChoose}>
            <div className="icon-svg">
              <DownloadOutlined />
            </div>
            <div className="text">Xuất DS </div>
          </div>
        </div>

        <div className="t-table-block custom-page-css flex flex-col flex-1 justify-between">
          <div className="ag-theme-alpine empty-test-td custom-table-ag-v2" style={{ width: '100%' }}>
            <AgGridReact
              ref={gridRef}
              domLayout="autoHeight"
              rowData={dataIssuedCards}
              columnDefs={columnDefs}
              defaultColDef={{ resizable: true, sortable: false }}
              rowSelection="multiple"
              rowMultiSelectWithClick={false}
              suppressRowClickSelection={true}
              getRowId={(params) => params.data.key.toString()}
              isRowSelectable={isRowSelectable}
              onSelectionChanged={onSelectionChanged}
              suppressDragLeaveHidesColumns
              loadingOverlayComponent={CustomLoadingOverlayTable}
              overlayNoRowsTemplate={NodataTable}
              rowHeight={55}
              getRowStyle={(params: any) => ({
                backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
            />
          </div>
          <ConfigProvider locale={viVN}>
            <div className="pagination-block flex justify-center">

              <Pagination
                total={pagination.total}
                current={paginationTmp}
                pageSize={pagination.pageSize}
                showSizeChanger
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, paginationTmp).totalPage} trang`}
                locale={{ items_per_page: 'trang' }}
                onChange={handleChangePagination}
              />
            </div>
          </ConfigProvider>
        </div>

        <div className={`show-access-filter ${accessSelectFilter ? "active" : ""}`}>
          <div className="title-access">
            <span>Lưu bộ lọc</span>
            <div className="icon-close">
              <CloseOutlined />
            </div>
          </div>
          <div className="input-add-name">
            <Input placeholder="Nhập tên bộ lọc" />
          </div>
          <div className="btn-footer-access">
            <div className="btn btn-primary" onClick={() => setActiveHiddenFilter()}>
              Lưu
            </div>
          </div>
        </div>

        {/* form add group customers 1 */}
        {/* {
          isAddCard
            ? <div
              className="group-customers-block"
            >
              <div className="title-access">
                <span>Phát hành thẻ</span>
                <div className="icon-close" onClick={() => setAddCard(false)}>
                  <CloseOutlined />
                </div>
              </div>
              <div className="modal-content">
                <div className="title-content">Xác nhận phát hành {selectedRowKeys.length} thẻ thành viên</div>
                <Select
                  className='t-select-ctrl'
                  defaultValue="Hạng thẻ"
                  // onChange={handleChange}

                  options={[
                    { value: 1, label: 'Thành viên Bạc' },
                    { value: 2, label: 'Thành viên Vàng' },
                    { value: 3, label: 'Thành viên kim cương' },
                  ]}
                />
              </div>
              <div className="btn-footer-access">
                <div className="btn btn-primary" onClick={() => setAddCardSuccess()}>
                  Tạo
                </div>
              </div>
            </div>
            : null
        } */}

        {
          isUserCard && <ShowDetailUserCard
            className="show"
            dataInfoCardCustomer={dataInfoCardCustomer}
            onClose={() => { setUserCard(false) }}
          />
        }
        {/* {
        isUserCard && <ShowDetailBenefit
          className="show"
          dataInfoCardCustomer={dataInfoCardCustomer}
          onClose={() => { setUserCard(false) }}
        />
      } */}



      </Layout>
    </div>
  );
}

export default CardIssuance;
